const state = {
   deviations: {},
}

export default state
